{
  "name": "crm-fe",
  "version": "1.0.6",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:dev": "ng serve --configuration local",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "lint": "ng lint --fix",
    "prepare": "cd ../../ && husky install",
    "api:generate": "graphql-codegen --config graphql-codegen.ts"
  },
  "main": "src/main.ts",
  "private": true,
  "dependencies": {
    "@adm/backend-entity": "1.0.0",
    "@adm/casl": "1.0.0",
    "@angular/animations": "^20.1.7",
    "@angular/cdk": "^20.1.5",
    "@angular/common": "^20.1.7",
    "@angular/compiler": "^20.1.7",
    "@angular/core": "^20.1.7",
    "@angular/forms": "^20.1.7",
    "@angular/google-maps": "^20.1.5",
    "@angular/material": "^20.1.5",
    "@angular/material-date-fns-adapter": "^20.1.5",
    "@angular/platform-browser": "^20.1.7",
    "@angular/platform-browser-dynamic": "^20.1.7",
    "@angular/router": "^20.1.7",
    "@angular/service-worker": "^20.1.7",
    "@apollo/client": "^3.0.0",
    "@casl/ability": "~6.5.0",
    "@casl/angular": "~9.0.4",
    "@googlemaps/js-api-loader": "^1.16.2",
    "@messageformat/core": "^3.4.0",
    "@ngrx/component-store": "^20.0.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@ngxs/storage-plugin": "^20.1.0",
    "@ngxs/store": "^20.1.0",
    "apollo-angular": "^11.0.0",
    "cropperjs": "^1.6.2",
    "date-fns": "^2.30.0",
    "extract-files": "^13.0.0",
    "graphql": "^16.8.1",
    "ngx-color-picker": "~20.0.0",
    "ngx-translate-messageformat-compiler": "^7.2.0",
    "tslib": "^2.3.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^20.1.1",
    "@angular-eslint/eslint-plugin": "^20.1.1",
    "@angular-eslint/eslint-plugin-template": "^20.1.1",
    "@angular-eslint/schematics": "^20.1.1",
    "@angular-eslint/template-parser": "^20.1.1",
    "@angular/build": "^20.1.6",
    "@angular/cli": "^20.1.6",
    "@angular/compiler-cli": "^20.1.7",
    "@graphql-codegen/cli": "^5.0.0",
    "@graphql-codegen/near-operation-file-preset": "^3.0.0",
    "@graphql-codegen/typescript": "^4.0.1",
    "@graphql-codegen/typescript-apollo-angular": "^4.0.0",
    "@graphql-codegen/typescript-operations": "^4.0.1",
    "@ngx-env/builder": "20.1.1",
    "@types/extract-files": "^13",
    "@types/jasmine": "~4.3.0",
    "@typescript-eslint/types": "^8.28.0",
    "@typescript-eslint/utils": "^8.28.0",
    "graphql-sock": "^1.0.1",
    "jasmine-core": "~4.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.8.2"
  },
  "peerDependencies": {
    "eslint": ">= 8.52.0",
    "rxjs": ">= 7.8.2"
  },
  "lint-staged": {
    "*.ts": [
      "prettier --write",
      "eslint --fix"
    ]
  }
}
